<section fxLayout="column">
  <img class="logo" src="/assets/general/logo_bluectrl_colour.svg">
  <h3>{{'DIALOGS.UPDATEAPP.TITLE' | i18next }}</h3>
  <p>{{'DIALOGS.UPDATEAPP.RUN' | i18next }}</p>
  <div class="spinner" fxLayout="row">
    <mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
  </div>
</section>
